/**
 * Custom error class for API related errors.
 * Includes service name, endpoint, status code and response data.
 */
class ApiError extends Error {
  constructor(message, { service, endpoint, status, data }) {
    super(message);
    this.name = "ApiError";
    this.service = service;
    this.endpoint = endpoint;
    this.status = status;
    this.data = data;
    
    // Ensure the stack trace is correct
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ApiError);
    }
  }

  /**
   * Helper to format the error for logging or UI display
   */
  toJSON() {
    return {
      name: this.name,
      message: this.message,
      service: this.service,
      endpoint: this.endpoint,
      status: this.status,
      data: this.data
    };
  }
}

export default ApiError;
